import { setContext } from '@apollo/client/link/context'
import { WEB_SESSION_GRANT, WEB_SESSION_HEADER, getWebSessionAccessToken } from './webSession'

export const AUTH_TOKEN_HEADER = 'Authorization'
const AUTH_TOKEN_STORAGE_KEY = 'authToken'

// The backend rejects requests carrying an invalid Bearer token even when a
// valid session cookie is present, so sign-in operations must stay header-free
const OPERATIONS_WITHOUT_AUTH_TOKEN = ['signInUser', 'signInThirdPartyUser']

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_STORAGE_KEY)

export const setAuthToken = (token: string) => localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token)

export const clearAuthToken = () => localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY)

// A web session's access token takes precedence over a long-lived token.
// Sign-in operations ask for a web session grant instead; the backend returns
// the long-lived token when web sessions are off for this origin.
export const authTokenLink = setContext(async (operation, { headers = {} }) => {
  if (OPERATIONS_WITHOUT_AUTH_TOKEN.includes(operation.operationName ?? '')) {
    return { headers: { ...headers, [WEB_SESSION_HEADER]: WEB_SESSION_GRANT } }
  }

  const token = (await getWebSessionAccessToken()) ?? getAuthToken()
  if (!token) return { headers }

  return { headers: { ...headers, [AUTH_TOKEN_HEADER]: `Bearer ${token}` } }
})
